import { useSearchParams } from "react-router-dom";
import { useAuthBindYaMutation } from "../../api/main/user";
import { useEffect, useState } from "react";

function BindYa() {

  const [log, setLog] = useState(null);
  const [loading, setLoading] = useState(false);
  const [authSuccess, setAuthSuccess] = useState(false);
  const [redirect, setRedirect] = useState(null);

  const [searchParams, setSearchParams] = useSearchParams();
  const code = searchParams.get("code");
  const device_id = searchParams.get("device_id");
  const state = searchParams.get("state");

  const [authBundYaApi] = useAuthBindYaMutation();

  useEffect(() => {
    authBundYaApi({ device_id: device_id, code: code, state: state })
      .unwrap()
      .then((res) => {
        console.log(res)
        setRedirect(res.Data.Redirect)
        if (res.Status !== 1) {
          setLog(res.Error);
          setLoading(false);
        }
        else {
          setAuthSuccess(true);
          return window.location.replace(res.Data.Redirect);
        }
      })
      .catch((err) => {
        setLog('Неизвестная ошибка!');
        setLoading(false);
      });
  }, []);

  return (
    <>
      <div className="row mt-5 mb-5">
        <div className="col-md-12 text-center">
          <h1>Привязка Yandexc ID</h1>
        </div>
      </div>

      {loading === true && (
        <div className="row mt-5 mb-5">
          <div className="col-md-12 text-center log_form">
            <span className="loader_01"></span>
          </div>
        </div>
      )}
      {log !== null && (
        <div className="row mt-5 mb-5">
          <div className="col-md-12 text-center log_form">
            {log}
            <br></br>
            <a href={redirect} className="card-link">Вернуться в настройки...</a>
          </div>
        </div>
      )}
      {authSuccess === true && (
        <>
          <div className="row mt-5 mb-5">
            <div className="col-md-12 text-center text-success">
              Yandex ID Успешно привязан. Для возвращения нажмите:
              <br></br>
              <a href={redirect} class="card-link">Вернуться в настройки...</a>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default BindYa;
